import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=c324590e&scoped=true&"
import script from "./Help.vue?vue&type=script&lang=js&"
export * from "./Help.vue?vue&type=script&lang=js&"
import style0 from "./Help.vue?vue&type=style&index=0&id=c324590e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c324590e",
  null
  
)

export default component.exports